import { axios } from "../../helpers/axios";
import {
    COMPANY_URL,
    USER_URL,
    GET_COMPANY_USERS_URL,
    CREATE_ACCOUNT,
    GET_COMPANY_PROCESS
} from "./accountConstants";

export const api_get_company_users_url = async (qc, qn, page, limit) => {
    return axios.get(GET_COMPANY_USERS_URL, { params: { qc, qn, page, limit } });
};

export const api_get_company_list_url = async (params) => {
    return axios.get(COMPANY_URL, { params });
};

export const api_create_account_url = async (data) => {
    return axios.post(CREATE_ACCOUNT, data);
};

export const api_activate_deactivate_users_url = async (user_id, data) => {
    return axios.patch(COMPANY_URL + "/" + user_id + "/" + data);
};

export const api_get_user_details_url = async (user_id) => {
    return axios.get(CREATE_ACCOUNT + "/" + user_id);
};

export const api_update_account_url = async (user_id, data) => {
    return axios.put(COMPANY_URL + USER_URL + '/' + user_id, data);
};


export const api_get_company_process_url = async () => {
    return axios.get(`${GET_COMPANY_PROCESS}`);
};